import React,{useEffect} from "react";
import './welcome.css'
import image from '../../images/me4.png'
import { NavLink } from "react-router-dom";
import Sidebar from "../../components/sidebar/sidebar"
import TypeWriterEffect from 'react-typewriter-effect';

export default function Welcome(){
    useEffect(()=>{
        window.scrollTo({top:0, left:0, behavior:'smooth'})
    })
    return(
        <div className="content_sidebar_wrapper">
            <Sidebar/>
            <div className="welcome_content">
                <img className="welcome_image" alt="/" src={image}></img>
                <div className="text_content">
                    <div className="Intro_text">
                        <h1>
                            <TypeWriterEffect
                                cursorColor="white"
                                startDelay={100}
                                text="Hello,"
                                typeSpeed={100}
                                hideCursorAfterText={true}
                            />
                        </h1>

                        <h1 className="name_welcome">
                            <TypeWriterEffect
                                textStyle={{ fontFamily: 'Red Hat Display',color: 'green', fontWeight:'200', fontSize: '2.8rem' }}
                                cursorColor="green"
                                startDelay={1000}
                                text="I'm Melvin,"
                                typeSpeed={100}
                                hideCursorAfterText={true}
                            />
                        </h1>

                        <h1>
                            <TypeWriterEffect
                                startDelay={2800}
                                text="A full Stack Developer"
                                typeSpeed={50}
                                hideCursorAfterText={true}
                            />
                            
                        </h1>
                    </div>
                    <p className="welcome_intro_text">
                        I have vast knowledge and practical experience in Web development, Computer programming, Database system, Networking, computer systems
                        and Microsoft office packages. Do you have a challenging position in a need of my abilities?. Are you a computer enthusiast looking for someone to partner with in a collaborative envilonment? <span className="worry_not">WORRY NOT, </span>  Contact me and i will get it done.
                    </p>
                    <div className="hire_me_buttons">
                        <NavLink to="./about_me" className="about_me_btn greenbtn" >About Me</NavLink>
                        <NavLink to="./contactme" className="hire_me_btn greenbtn">Hire Me</NavLink>
                    </div>
               
                </div>
                
            </div>
        </div>
            
    )
}